import { render, staticRenderFns } from "./OrderReservePending.vue?vue&type=template&id=421480b2"
import script from "./OrderReservePending.vue?vue&type=script&lang=js"
export * from "./OrderReservePending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports